/*
 * @Descripttion:
 * @Author: Niu Chenxin
 * @Date: 2020-12-02 09:20:20
 * @LastEditors: Niu Chenxin
 * @LastEditTime: 2021-01-05 11:14:21
 */
import Http from './../http'
import md5 from 'js-md5'
export default {
  // 获取当前用户信息条数
  getCount(params, callback) {
    Http.get(
      Http.harvardBaseURL + '/like/countMessage/ZBvOm0ocQSUykUX5',
      params,
      (res) => {
        callback(res)
      }
    )
  },
  // 获取未读消息点赞数
  getCountLike(urlParams, params, callback) {
    Http.post(
      Http.harvardBaseURL + '/like/countLikes/ZBvOm0ocQSUykUX5',
      urlParams,
      params,
      (res) => {
        callback(res)
      }
    )
  },
  // 获取点赞信息列表
  getLikeList(urlParams, params, callback) {
    Http.post(
      Http.harvardBaseURL + '/like/list/ZBvOm0ocQSUykUX5',
      urlParams,
      params,
      (res) => {
        callback(res)
      }
    )
  },
  // 获取回复信息列表
  getReplyList(urlParams, params, callback) {
    Http.post(
      Http.harvardBaseURL + '/comment/getReplyMessage/ZBvOm0ocQSUykUX5',
      urlParams,
      params,
      (res) => {
        callback(res)
      }
    )
  },
  // 点赞更新消息状态
  getNewsState(params, callback) {
    Http.get(
      Http.harvardBaseURL + '/like/updateIsRead/ZBvOm0ocQSUykUX5',
      params,
      (res) => {
        callback(res)
      }
    )
  },
  // 回复更新消息状态
  getReplyState(params, callback) {
    Http.get(
      Http.harvardBaseURL + '/comment/updateReadState/ZBvOm0ocQSUykUX5',
      params,
      (res) => {
        callback(res)
      }
    )
  },
  // 点赞
  onLike(urlParams, params, callback) {
    Http.post(
      Http.harvardBaseURL + '/like/add/ZBvOm0ocQSUykUX5',
      urlParams,
      params,
      (res) => {
        callback(res)
      }
    )
  },
  // 取消点赞
  cancelLike(urlParams, params, callback) {
    Http.post(
      Http.harvardBaseURL + '/like/cancel/ZBvOm0ocQSUykUX5',
      urlParams,
      params,
      (res) => {
        callback(res)
      }
    )
  },
  //种草社区点赞，取消赞
  grassGrowingLike(urlParams, params, callback) {
    Http.post(
      Http.hostName + '/xmh/lucky/comment/like',
      urlParams,
      params,
      (res) => {
        callback(res)
      }
    )
  },
  //种草社区回复提交
  grassGrowingSubmitComment(urlParams, params, callback) {
    Http.post(
      Http.hostName + '/xmh/lucky/comment/save',
      urlParams,
      params,
      (res) => {
        callback(res)
      }
    )
  },
  // 回复评论
  submitComment(urlParams, params, callback) {
    let date = Date.parse(new Date())
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    let appkey = '10002'
    let appSecret = 'HDKumsH47xXUAymRkPgLQt9qL9Odjljk'
    let sign = md5(
      appSecret + 'timestamp' + date + 'crmId' + userInfo.crm_id + appSecret
    ).toUpperCase()
    Http.post(
      Http.harvardBaseURL +
        '/comment/save/reply/ZBvOm0ocQSUykUX5?sign=' +
        sign +
        '&tunestamp=' +
        date,
      urlParams,
      params,
      (res) => {
        callback(res)
      }
    )
  },
}
